import { tv } from 'tailwind-variants';

export const newsStyles = tv({
  slots: {
    icon: ['size-full', 'text-primary-700'],
    clickable: ['hover:text-primary-800', 'hover:underline'],
    primary: ['font-semibold', 'text-primary-700'],
    pageReference: [
      'rounded',
      'bg-primary-100',
      'px-1',
      'font-semibold',
      'text-primary-600',
      'transition-colors',
      'duration-300',
    ],
  },
});
